import { render } from "./dl-footer.vue?vue&type=template&id=be4a9d30"
import script from "./dl-footer.vue?vue&type=script&lang=js"
export * from "./dl-footer.vue?vue&type=script&lang=js"

import "./dl-footer.vue?vue&type=style&index=0&id=be4a9d30&lang=scss"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__